import React from "react";
import { Modal } from "./Modal";

const SelectedTechModal = ({
  tech,
  similarity,
  transitionDifficulty,
  substitutability,
  comparisonTechName,
  show,
  onClose,
}) => {
  return (
    <Modal
      show={show}
      className="md:w-full lg:w-full max-w-[640px]"
      onClose={onClose}
    >
      <div className="mb-4">
        <h2 className="text-xl font-bold">{tech.name}</h2>
        <p className="text-xs text-gray-600">
          Substitutability with {comparisonTechName}:{" "}
          {substitutability ? (
            <span className="font-bold">{substitutability?.grade}</span>
          ) : (
            "Loading..."
          )}
        </p>
        <p className="text-xs text-gray-600">
          Similarity to {comparisonTechName}:{" "}
          {similarity ? (
            <span className="font-bold">{similarity?.grade}</span>
          ) : (
            "Loading..."
          )}
        </p>
        <p className="text-xs text-gray-600">
          Difficulty transitioning from {comparisonTechName}:{" "}
          {transitionDifficulty ? (
            <span className="font-bold">{transitionDifficulty}</span>
          ) : (
            "Loading..."
          )}
        </p>
      </div>
      <p className="mb-4">{tech.short_eli5_description} {tech.description}</p>
      <div className="grid grid-cols-2 divide-x divide-gray-300">
        <div className="pr-2">
          <p className="text-xs font-semibold text-gray-600 text-center">
            Similarities
          </p>
          <p className="text-xs text-gray-600">{tech.similarities}</p>
        </div>
        <div className="pl-2">
          <p className="text-xs font-semibold text-gray-600 text-center">
            Differences
          </p>
          <p className="text-xs text-gray-600">{tech.differences}</p>
        </div>
      </div>
    </Modal>
  );
};

export default SelectedTechModal;
